import { render, staticRenderFns } from "./domain-chooser.vue?vue&type=template&id=bbc436c0&scoped=true"
import script from "./domain-chooser.vue?vue&type=script&lang=ts"
export * from "./domain-chooser.vue?vue&type=script&lang=ts"
import style0 from "./domain-chooser.vue?vue&type=style&index=0&id=bbc436c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc436c0",
  null
  
)

export default component.exports